import { RouteRecordRaw } from 'vue-router';

export const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    component: () => import('../pages/_layout/AuthLayout.vue'),
    meta: { scope: 'auth', title: 'EW WMS' },
    children: [
      { path: 'login', name: 'auth.login', component: () => import('../pages/Login.vue') },
      { path: 'logout', name: 'auth.logout', component: () => import('../pages/Logout.vue') },
    ],
  },
];
